import {rootState} from '@mintdata-wsp/common/state/RootState';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {VisualDesignerContainer} from '@mintdata-wsp/wsp/ui/views/visualDesigner/container/VisualDesignerContainer';
import {FlowEditor} from '@mintdata-wsp/wsp/ui/views/visualDesigner/flow/FlowEditor';
import * as classnames from 'classnames/bind';
import {action} from 'mobx';
import {observer} from 'mobx-react';
import * as React from 'react';
import {RouteComponentProps} from 'react-router';

const styles = require('./SampleDesignPage.less');
const cx = classnames.bind(styles);

@observer
export class SampleDesignPage extends React.Component<RouteComponentProps<any>, any>
{
    constructor(props:RouteComponentProps<any>)
    {
        super(props);
        controllers.ui.sampleDesign.init(props);
    }

    @action
    componentWillReceiveProps(nextProps:Readonly<RouteComponentProps<any>>, nextContext:any):void
    {
        controllers.ui.sampleDesign.init(nextProps);
    }

    @action
    public async componentWillUnmount():Promise<void>
    {
        //  Performing necessary cleanup
        const {openDesign} = controllers.ui;

        await openDesign.performDesignCleanup();
        openDesign.setSampleDesignMode(null);
    }

    public render():JSX.Element
    {
        const {sampleDesign} = rootState.ui.visualDesigner;

        if( !sampleDesign ) return null;

        if( sampleDesign.showFlowEditor )
            return (
                <div>
                    <FlowEditor />
                </div>
            );
        else
            return (
                <div className={cx('visualDesignerHolder')}>
                    <VisualDesignerContainer />
                </div>
            );
    }
}
